import { z } from 'zod';

export const oldDashboardSchema = z.object({
  questionId: z.number().optional(),
  name: z.string(),
});

export const newDashboardSchema = z.object({
  name: z.string(),
  id: z.number().optional(),
  type: z.enum(['dashboard', 'question']),
  locked_params: z.array(
    z.object({
      param_type: z.enum(['id', 'single_date', 'date_range']),
      param_name: z.string(),
      param_value: z.string(),
    }),
  ),
  filterable_params: z.array(
    z.object({
      param_type: z.enum(['id', 'single_date', 'date_range']),
      param_name: z.string(),
      param_value: z.string(),
    }),
  ),
  hidden_filters: z.array(z.string()).optional(),
});

export const dashboardConfigSchema = z.array(z.union([oldDashboardSchema, newDashboardSchema]));
